/* eslint react/forbid-prop-types: 0 */

import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import {
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import qs from 'qs';

import { canAccessRestrictedModule } from './moduleAccess';

export function hasGroupAccess(comp, allowedGroups) {
  const GroupAccess = ({
    groups,
  }) => {
    if (allowedGroups.some(ag => groups.some(g => g.code === ag))) {
      return comp;
    }
    return null;
  };

  GroupAccess.propTypes = {
    groups: PropTypes.array,
  };

  const mapStateToProps = state => ({
    groups: state.auth.groups,
  });

  return connect(mapStateToProps)(GroupAccess);
}

export function hasAccess(Comp) {
  class Authenticated extends Component {
    componentWillMount() {
      this.checkAuth(this.props.isAuthenticated);
    }
    componentWillReceiveProps(nextProps) {
      this.checkAuth(nextProps.isAuthenticated);
    }
    checkAuth(isAuthenticated) {
      const { store } = this.context;
      if (!isAuthenticated) {
        const query = Object.assign({}, this.props.location.query);
        const queries = qs.stringify(query) ? '?'.concat(qs.stringify(query)) : '';
        const hash = this.props.location.hash ? this.props.location.hash : '';
        let nextBase64 = null;
        if (this.props.location.pathname.length > 0) {
          try {
            nextBase64 = btoa(this.props.location.pathname + queries + hash);
          } catch (e) {
            Bugsnag.notifyException(e);
          }
        }
        store.dispatch(replace(`/loading/?${nextBase64 ? `next=${nextBase64}` : ''}`));
      }
    }
    render() {
      return (
        <Suspense
          fallback={
            <Dimmer style={{ zIndex: 20 }} active inverted>
              <Loader inline="centered">Loading</Loader>
            </Dimmer>
          }
        >
          <div>
            {this.props.isAuthenticated === true
            ? <Comp {...this.props} />
            : null
          }
          </div>
        </Suspense>
      );
    }
  }

  Authenticated.propTypes = {
    isAuthenticated: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      hash: PropTypes.string,
      query: PropTypes.object,
    }),
  };

  Authenticated.contextTypes = {
    store: PropTypes.object,
  };

  const mapStateToProps = state => ({
    email: state.auth.email,
    isAuthenticated: state.auth.isAuthenticated,
  });

  return connect(mapStateToProps)(Authenticated);
}

export function hasAffiliateAccess(Comp) {
  const AffiliateAccess = ({ allowEditUnitPrice, allowEditUnitDetails, ...props }, { store }) => {
    if (allowEditUnitPrice || allowEditUnitDetails) {
      return <Comp {...props} />;
    }
    store.dispatch(replace('/forbidden/'));
    return null;
  };

  AffiliateAccess.propTypes = {
    allowEditUnitPrice: PropTypes.bool,
    allowEditUnitDetails: PropTypes.bool,
  };

  AffiliateAccess.contextTypes = {
    store: PropTypes.object,
  };

  const mapStateToProps = state => ({
    allowEditUnitPrice: state.auth.allowEditUnitPrice,
    allowEditUnitDetails: state.auth.allowEditUnitDetails,
  });

  return connect(mapStateToProps)(AffiliateAccess);
}

export function hasRestrictedModuleAccess(Comp) {
  const RestrictedModuleAccess = ({ auth, ...props }, { store }) => {
    if (!canAccessRestrictedModule(auth)) {
      store.dispatch(replace('/forbidden/'));
      return null;
    }
    return <Comp {...props} />;
  };

  RestrictedModuleAccess.propTypes = {
    auth: PropTypes.object,
  };

  RestrictedModuleAccess.contextTypes = {
    store: PropTypes.object,
  };

  const mapStateToProps = state => ({
    auth: state.auth,
  });

  return connect(mapStateToProps)(RestrictedModuleAccess);
}

export function hasInternalAccess(Comp) {
  const InternalAccess = ({ companyBranch, ...props }, { store }) => {
    if (companyBranch && companyBranch.isExternal) {
      store.dispatch(replace('/forbidden/'));
      return null;
    }
    return <Comp {...props} />;
  };

  InternalAccess.propTypes = {
    companyBranch: PropTypes.shape({
      isExternal: PropTypes.bool,
    }),
  };

  InternalAccess.contextTypes = {
    store: PropTypes.object,
  };

  const mapStateToProps = state => ({
    companyBranch: state.auth.companyBranch,
  });

  return connect(mapStateToProps)(InternalAccess);
}



// WEBPACK FOOTER //
// ./src/utils/auth.jsx